import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router } from "@angular/router";

import { FornecedorService } from '../services/fornecedor.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fornecedores',
  templateUrl: './fornecedores.component.html',
  styleUrls: ['./fornecedores.component.css'],
  animations: [loadingFade, modal, alert]
})
export class FornecedoresComponent implements OnInit {

  public menu_id = 159;	
	
  public loading = false;
  public fornecedores;

  public page = 1;
  public limit = 10;
  public count = 0;

  	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	
  
  constructor(
              private fornecedorSvc: FornecedorService
			  ,private authSvc: AuthService
			  ,private route: ActivatedRoute
			  ,private perfilUsuarioSvc: PerfilUsuarioService
  ) { }

  ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  	


    this.pegaFornecedores();
  }

	pegaFornecedores(){
		this.loading = true;
		this.fornecedorSvc.getFornecedores().then((data: any) => {
			this.fornecedores = data;
			this.count = this.fornecedores.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
  }
  
  primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
  }

  	apagaFornecedores(id) {
	  Swal.fire({
	  	type:'warning',
	  	title: 'Deseja realmente apagar este registro?',
	  	showCancelButton: true,
	  	showCloseButton: true,
	  	confirmButtonText: 'Apagar',
	  	cancelButtonText: 'Cancelar',
	  	confirmButtonColor: '#d33'

	}).then((result) => {
		if(result.value == true){
			this.fornecedorSvc.apagaFornecedores(id).then((data) => {
				this.pegaFornecedores();
				Swal.fire({
					type: 'success',
					title: 'Apagado com sucesso!'
				});
			}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
	  	})
  	}
}
